interface DepartmentJobTitleLengths {
  departmentName: string;
  jobTitle: string;
}

export class RegistrationUtils {
  static getJapaneseDepartmentAndJobTitle(
    departmentName: string,
    jobTitle: string,
    maxLen: number
  ): DepartmentJobTitleLengths {
    const fields: DepartmentJobTitleLengths = {
      jobTitle: jobTitle.length > maxLen ? jobTitle.slice(0, maxLen) : jobTitle,
      departmentName: departmentName.length > maxLen ? departmentName.slice(0, maxLen) : departmentName
    };
    const departmentAndJobTitleLength = departmentName.length + jobTitle.length + 1;
    if (departmentName.length === maxLen && jobTitle.length) {
      fields.jobTitle = '';
    }
    if (departmentName.length && departmentName.length < maxLen && departmentAndJobTitleLength > maxLen) {
      const maxAllowedJobTitleLength = maxLen - departmentName.length - 1;
      fields.jobTitle = jobTitle.slice(0, maxAllowedJobTitleLength);
    }
    return fields;
  }
}
